import { useState, useEffect } from "react";

const Logo = () => {
  const [logo, setLogo] = useState(`${process.env.PUBLIC_URL}/whitezzlogo.svg`); // Start with the SVG version

  useEffect(() => {
    const gifDuration = 3000; // Duration of the GIF in milliseconds
    const hasPlayed = sessionStorage.getItem("hasPlayedLogoAnimation");

    if (!hasPlayed) {
      // Play the GIF only if the animation hasn't played yet this session
      setLogo(`${process.env.PUBLIC_URL}/whitezzlogo.gif`);

      const timer = setTimeout(() => {
        // Replace GIF with SVG after it finishes
        setLogo(`${process.env.PUBLIC_URL}/whitezzlogo.svg`);
        sessionStorage.setItem("hasPlayedLogoAnimation", "true"); // Mark animation as played in sessionStorage
      }, gifDuration);

      return () => clearTimeout(timer); // Clean up the timer when the component unmounts
    }
  }, []);

  return (
    <img
      src={logo}
      alt="Zenzero Logo"
      style={{ width: "200px", height: "auto" }} // Adjust width and height as needed
    />
  );
};

export default Logo;
